import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";
import loggingUserSlice from "../features/loggingUser/loggingUserSlice";
import newOrderSlice from "../features/newOrder/newOrderSlice";
import openOrderSlice from "../features/openOrder/openOrderSlice";
import closedOrderSlice from "../features/closedOrder/closedOrderSlice";
import orderDetailsSlice from "../features/orderDetails/orderDetailsSlice";
import settingsSlice from "../features/settings/settingsSlice";
import newJobworkSlice from "../features/newJobwork/newJobworkSlice";
import openJobworkSlice from "../features/openJobwork/openJobworkSlice";
import jobworkDetailsSlice from "../features/jobworkDetails/jobworkDetailsSlice";
import closedJobworkSlice from "../features/closedJobwork/closedJobworkSlice";
import newSampleSlice from "../features/newSample/newSampleSlice";
import openSampleSlice from "../features/openSample/openSampleSlice";
import sampleDetailsSlice from "../features/sampleDetails/sampleDetailsSlice";
import closedSampleSlice from "../features/closedSample/closedSampleSlice";

export const store = configureStore({
  reducer: {
    loggingUser: loggingUserSlice,
    newOrder: newOrderSlice,
    openOrder: openOrderSlice,
    closedOrder: closedOrderSlice,
    orderDetails: orderDetailsSlice,
    settings: settingsSlice,
    newJobwork: newJobworkSlice,
    openJobwork: openJobworkSlice,
    jobworkDetails: jobworkDetailsSlice,
    closedJobwork: closedJobworkSlice,
    newSample: newSampleSlice,
    openSample: openSampleSlice,
    closedSample: closedSampleSlice,
    sampleDetails: sampleDetailsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
